var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .chevron-line.icon-line--style {\n                stroke-width: 2.3;\n            }\n          ")),React.createElement("title",{"key":1},"chevron-up"),React.createElement("desc",{"key":2},"Created with Sketch."),React.createElement("g",{"id":"chevron-up","stroke":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":3},React.createElement("polyline",{"className":"chevron-line icon-line--style","stroke":"currentcolor","fill":"none","id":"Line","points":"1.15307617 6.847229 6.9956665 1.15771484 12.859314 6.85333252"}))]);
}

Chevron.defaultProps = {"width":"14px","height":"8px","viewBox":"0 0 14 8","version":"1.1"};

module.exports = Chevron;

Chevron.default = Chevron;
